import { createActionGroup, props } from "@ngrx/store";
import { guid, MinimumSlideInformation } from "@pcp/core/interfaces";
import { NavigationPreviewNextSlideData } from "../store/classroomState";

/**
 * Connection-lifecycle and navigation-preview actions consumed by the local
 * NgRx reducer.
 *
 * Renamed from `classroomActions` in 2026-05 to avoid the case-collision with
 * the unrelated cross-feature event-bus namespace (then `ClassroomActions`,
 * today `ClassroomEvents`) re-exported from the lib's barrel. The two were
 * distinguishable only by case, which made
 * `import { ClassroomActions, classroomActions }` legal and confusing.
 * The lowercase `classroomEvents` lifecycle group was renamed
 * `classroomLifecycleEvents` in 2026-07 for the same reason when
 * `ClassroomEvents` was introduced.
 *
 * The source string is also `ClassroomConnectionActions` (was `ClassroomActions`)
 * so Redux DevTools / log scraping reflect the new name.
 */
export const classroomConnectionActions = createActionGroup({
    source: "ClassroomConnectionActions",
    events: {
        connectToClassroom: props<{ lessonId: guid }>(),
        connectToClassroomSuccess: props<{
            lessonId: guid,
            studentRegistrationCode: string,
            customer: string,
            teacher: guid,
            start: string,
            presentationId: string,
        }>(),
        connectToClassroomFailed: props<{ error: any }>(),
        setNavigationPreviewBasicSlides: props<{
            slides: MinimumSlideInformation[];
            hasParent: boolean;
        }>(),
        setNavigationPreviewNextSlides: props<{
            data: NavigationPreviewNextSlideData | null;
        }>(),
    }
});
